<template>
  <div class="top clearfix">
    <div class="logo">
      <div class="auto">
        <img src="../assets/image/logo.jpg" alt />
        <img src="../assets/image/logo2.jpg" alt />
      </div>
    </div>
    <div class="tBanner" @mouseleave="swplay" @mouseenter="swout">
      <!-- <div class="swiper-pagination" id="swiper-pagination"></div> -->
      <swiper :options="swiperOptionSwp1" ref="swiperOptionSwp" class="gallery-top">
        <div class="swiper-slide" v-for="(data,index) in data" :key="index">
          <div :data-background="data.url" class="swiper-slide swiper-lazy">
            <div class="swiper-lazy-preloader"></div>
          </div>
        </div>
        <div class="swiper-button-prev" id="swiper-button-prev1" slot="button-prev"></div>
        <div class="swiper-button-next" id="swiper-button-next1" slot="button-next"></div>
      </swiper>
      <div class="swiper-pagination swiper-pagination1" id="swiper-pagination" slot="pagination"></div>
      <div class="botColor">
        <div class="auto">
          <img src="../assets/image/headbannerbot1.jpg" alt />
          <img src="../assets/image/headbannerbot2.jpg" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: [
        { url: require("../assets/image/headbanner1.jpg?1") },
        { url: require("../assets/image/headbanner2.jpg?2") },
        { url: require("../assets/image/headbanner3.jpg?2") }
      ],
      swiperOptionSwp1: {
        navigation: {
          nextEl: "#swiper-button-next1",
          prevEl: "#swiper-button-prev1"
        },
        // loop: true,
        autoplay: {
          //播放时间间隔
          delay: 3000,
          disableOnInteraction: false
        },
        lazy: {
          loadPrevNext: true
        },
        pagination: {
          el: ".swiper-pagination1",
          clickable: true,
          renderBullet: function(index, className) {
            return (
              '<span class="' +
              className +
              '"><image src="http://zt.photofans.cn/canon/2019/1126/img/headbanernavpage' +
              (index + 1) +
              '.jpg?2"></span>'
            );
          }
        }
      }
    };
  },
  methods: {
    swout() {
      this.$refs.swiperOptionSwp.swiper.autoplay.stop();
    },
    swplay() {
      this.$refs.swiperOptionSwp.swiper.autoplay.start();
    }
  }
};
</script>
<style scoped>
#swiper-button-prev1,
#swiper-button-next1 {
  width: 51px;
  height: 94px;
}
#swiper-button-prev1 {
  left: 5%;
  background: url(../assets/image/top_jtl.png);
}
#swiper-button-next1 {
  right: 5%;
  background: url(../assets/image/top_jtr.png);
}
.top {
  float: left;
  width: 100%;
  min-width: 1200px;
  max-width: 1920px;
}
.logo {
  float: left;
  width: 100%;
  height: 84px;
  background: #fff;
}
.auto {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  height: 100%;
}
.auto img {
  position: absolute;
  top: 0;
}
.auto img:nth-child(1) {
  left: -85px;
}
.auto img:nth-child(2) {
  right: -96px;
}
.tBanner {
  position: relative;
  float: left;
  width: 100%;
  height: 835px;
}
/* .swiper-slide {
  background-position: center;
  background-size: cover;
}
.swiper-container {
  height: 739px;
}
.gallery-thumbs {
  height: 94px;
  border: 1px solid #ddd;
  background: #eee;
}
.gallery-thumbs .swiper-slide {
  height: 62px;
} */
.swiper-container {
  width: 100%;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
}
.gallery-top {
  height: 739px;
  width: 100%;
}
.swiper-pagination {
  height: 62px;
  /* width: 440px; */
}
.botColor {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #eee;
  height: 94px;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.botColor .auto {
  position: relative;
  width: 1200px;
  margin: 0 auto;
}
.botColor img {
  position: absolute;
  top: 0;
}
.botColor img:nth-child(1) {
  left: 0;
}
.botColor img:nth-child(2) {
  right: 0;
}
</style>